"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ = require("./");

class EvaluationSection {
  static thaw(evaluationSectionObj) {
    if (evaluationSectionObj == null) return null;
    const evaluationSection = new EvaluationSection();
    if (evaluationSectionObj.id != null) evaluationSection.setId(evaluationSectionObj.id);
    if (evaluationSectionObj.name != null) evaluationSection.setName(evaluationSectionObj.name);
    if (evaluationSectionObj.isSkippable != null) evaluationSection.setIsSkippable(evaluationSectionObj.isSkippable);
    if (evaluationSectionObj.segmentId != null) evaluationSection.setSegmentId(evaluationSectionObj.segmentId);
    if (evaluationSectionObj.questions != null) evaluationSection.setQuestions(_.EvaluationQuestion.thawList(evaluationSectionObj.questions));
    if (evaluationSectionObj.segment != null) evaluationSection.setSegment(_.ErgoAlgoSegment.thaw(evaluationSectionObj.segment));
    if (evaluationSectionObj.sectionAnswer != null) evaluationSection.setSectionAnswer(_.EvaluationSectionAnswer.thaw(evaluationSectionObj.sectionAnswer));
    return evaluationSection;
  }

  static thawList(evaluationSectionObjList) {
    if (evaluationSectionObjList == null) return [];
    var evaluationSections = [];

    for (var i = 0; i < evaluationSectionObjList.length; i++) {
      evaluationSections.push(EvaluationSection.thaw(evaluationSectionObjList[i]));
    }

    return evaluationSections;
  }

  static freeze(evaluationSection) {
    if (evaluationSection == null) return null;
    var evaluationSectionObj = {};
    if (evaluationSection.getId() != null) evaluationSectionObj.id = evaluationSection.getId();
    if (evaluationSection.getName() != null) evaluationSectionObj.name = evaluationSection.getName();
    if (evaluationSection.getIsSkippable() != null) evaluationSectionObj.isSkippable = evaluationSection.getIsSkippable();
    if (evaluationSection.getSegmentId() != null) evaluationSectionObj.segmentId = evaluationSection.getSegmentId();
    if (evaluationSection.getQuestions() != null) evaluationSectionObj.questions = _.EvaluationQuestion.freezeList(evaluationSection.getQuestions());
    if (evaluationSection.getSegment() != null) evaluationSectionObj.segment = _.ErgoAlgoSegment.freeze(evaluationSection.getSegment());
    if (evaluationSection.getSectionAnswer() != null) evaluationSectionObj.sectionAnswer = _.EvaluationSectionAnswer.freeze(evaluationSection.getSectionAnswer());
    return evaluationSectionObj;
  }

  static freezeList(evaluationSections) {
    if (evaluationSections == null) return [];
    var evaluationSectionObjList = [];

    for (var i = 0; i < evaluationSections.length; i++) {
      evaluationSectionObjList.push(EvaluationSection.freeze(evaluationSections[i]));
    }

    return evaluationSectionObjList;
  }

  constructor() {
    this.setId(null);
    this.setName(null);
    this.setIsSkippable(null);
    this.setSegmentId(null);
    this.setQuestions(null);
    this.setSegment(null);
    this.setSectionAnswer(null);
  }
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  setId(id) {
    this.id = id;
  }

  setName(name) {
    this.name = name;
  }

  setIsSkippable(isSkippable) {
    this.isSkippable = isSkippable;
  }

  setSegmentId(segmentId) {
    this.segmentId = segmentId;
  }

  setQuestions(questions) {
    this.questions = questions;
  }

  setSegment(segment) {
    this.segment = segment;
  }

  setSectionAnswer(sectionAnswer) {
    this.sectionAnswer = sectionAnswer;
  }
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  getId() {
    return this.id;
  }

  getName() {
    return this.name;
  }

  getIsSkippable() {
    return this.isSkippable;
  }

  getSegmentId() {
    return this.segmentId;
  }

  getQuestions() {
    return this.questions;
  }

  getSegment() {
    return this.segment;
  }

  getSectionAnswer() {
    return this.sectionAnswer;
  }
  /* -------------------------
     -------------------------
     -------- HELPERS --------
     -------------------------
     ------------------------- */


}

exports.default = EvaluationSection;